import { AxiosError } from "axios";
import http from "infra/http";
import { useMutation } from "react-query";

export function useExcluirAnimal() {
  return useMutation<{ success: boolean }, AxiosError, string>(
    async (id: string) => {
      const { data } = await http.delete(`/v1/animal/${id}`);

      return data;
    },
    {
      retry: false,
    }
  );
}
